module.exports = __webpack_public_path__ + "static/media/modelo-envio-pontos.dc07c05e.xls";